const ICON_PATHS = {
  'arrow-left': ['M19 12H5', 'M12 19l-7-7 7-7'],
  check: ['M20 6L9 17l-5-5'],
  'chevron-down': ['M6 9l6 6 6-6'],
  'chevron-up': ['M18 15l-6-6-6 6'],
  copy: [
    'M9 9h10a2 2 0 012 2v8a2 2 0 01-2 2H9a2 2 0 01-2-2V11a2 2 0 012-2z',
    'M15 9V5a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2h2',
  ],
  edit: ['M12 20h9', 'M16.5 3.5a2.12 2.12 0 013 3L8 18l-4 1 1-4z'],
  ellipsis: [
    'M5 12h.01',
    'M12 12h.01',
    'M19 12h.01',
  ],
  'external-link': [
    'M14 3h7v7',
    'M10 14L21 3',
    'M21 14v5a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h5',
  ],
  'grip-vertical': ['M9 5h.01', 'M9 12h.01', 'M9 19h.01', 'M15 5h.01', 'M15 12h.01', 'M15 19h.01'],
  image: [
    'M3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2z',
    'M8.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3z',
    'M21 15l-5-5L5 21',
  ],
  minus: ['M5 12h14'],
  plus: ['M12 5v14', 'M5 12h14'],
  trash: [
    'M3 6h18',
    'M8 6V4h8v2',
    'M19 6l-1 15H6L5 6',
    'M10 11v6',
    'M14 11v6',
  ],
  x: ['M18 6L6 18', 'M6 6l12 12'],

  // Promo tools icons: entries containing "<" are raw inner-SVG markup
  // (mixed element types), rendered as-is by GsIcon below.
  search: '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>',
  download: '<path d="M12 3v12"/><path d="M7 10l5 5 5-5"/><path d="M4 21h16"/>',
  link: '<path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.5 1.5"/><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.5-1.5"/>',
  code: '<path d="M16 18l6-6-6-6"/><path d="M8 6l-6 6 6 6"/>',
  settings: '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"/>',
  star: '<path d="M12 2l3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1z"/>',
  eye: '<path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/><circle cx="12" cy="12" r="3"/>',
  bold: '<path d="M6 4h8a4 4 0 0 1 0 8H6z"/><path d="M6 12h9a4 4 0 0 1 0 8H6z"/>',
  italic: '<path d="M19 4h-9"/><path d="M14 20H5"/><path d="M15 4L9 20"/>',
  underline: '<path d="M6 3v7a6 6 0 0 0 12 0V3"/><path d="M4 21h16"/>',
  strikethrough: '<path d="M16 4H9a3 3 0 0 0-2.8 4"/><path d="M14 12a4 4 0 0 1 0 8H6"/><path d="M4 12h16"/>',
  heading: '<path d="M6 4v16"/><path d="M18 4v16"/><path d="M6 12h12"/>',
  'list-ul': '<path d="M8 6h13"/><path d="M8 12h13"/><path d="M8 18h13"/><path d="M3 6h.01"/><path d="M3 12h.01"/><path d="M3 18h.01"/>',
  'list-ol': '<path d="M10 6h11"/><path d="M10 12h11"/><path d="M10 18h11"/><path d="M4 6h1v4"/><path d="M4 10h2"/><path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"/>',
  quote: '<path d="M7 17H4a2 2 0 0 1-2-2v-3a6 6 0 0 1 6-6"/><path d="M21 17h-3a2 2 0 0 1-2-2v-3a6 6 0 0 1 6-6"/>',
  'align-left': '<path d="M21 6H3"/><path d="M15 12H3"/><path d="M17 18H3"/>',
  'align-center': '<path d="M21 6H3"/><path d="M17 12H7"/><path d="M19 18H5"/>',
  'align-right': '<path d="M21 6H3"/><path d="M21 12H9"/><path d="M21 18H7"/>',
  undo: '<path d="M3 7v6h6"/><path d="M21 17a9 9 0 0 0-15-6.7L3 13"/>',
  redo: '<path d="M21 7v6h-6"/><path d="M3 17a9 9 0 0 1 15-6.7L21 13"/>',
  eraser: '<path d="M20 20H7L3 16a2 2 0 0 1 0-2.8l9.2-9.2a2 2 0 0 1 2.8 0l5.7 5.7a2 2 0 0 1 0 2.8L13 20"/><path d="M6 11l7 7"/>',
  play: '<path d="M6 4l14 8-14 8z"/>',
  logout: '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="M16 17l5-5-5-5"/><path d="M21 12H9"/>',
  chart: '<path d="M3 3v18h18"/><path d="M7 15l4-4 3 3 5-6"/>',
  share: '<circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4"/><path d="M15.4 6.5l-6.8 4"/>',
  'minus-circle': '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  users: '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.9"/><path d="M16 3.1a4 4 0 0 1 0 7.8"/>',
};

const GsIcon = {
  name: 'GsIcon',
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      default: 16,
    },
  },
  render(h) {
    const entry = ICON_PATHS[this.name] || ICON_PATHS.ellipsis;
    const attrs = Object.assign(
      {
        width: this.size,
        height: this.size,
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': 2,
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        focusable: 'false',
        'aria-hidden': this.$attrs['aria-label'] ? null : 'true',
      },
      this.$attrs
    );
    const data = {
      class: ['gs-icon', `gs-icon--${this.name}`],
      attrs,
    };

    // Some entries are a single raw inner-SVG markup string (mixed element
    // types like <circle>/<rect>/<path>); the rest remain plain arrays of
    // path `d` strings, rendered as before.
    if (typeof entry === 'string' && entry.indexOf('<') !== -1) {
      data.domProps = { innerHTML: entry };
      return h('svg', data);
    }

    const paths = Array.isArray(entry) ? entry : [entry];
    return h('svg', data, paths.map(path => h('path', { attrs: { d: path } })));
  },
};

const GsButton = {
  name: 'GsButton',
  inheritAttrs: false,
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: 'md',
    },
    type: {
      type: String,
      default: 'button',
    },
    disabled: Boolean,
    loading: Boolean,
  },
  render(h) {
    const attrs = Object.assign({}, this.$attrs, {
      type: this.type,
      disabled: this.disabled || this.loading,
      'aria-busy': this.loading ? 'true' : null,
    });
    const content = this.loading
      ? [h('span', { class: 'gs-button__spinner', attrs: { 'aria-hidden': 'true' } }), this.$slots.default]
      : this.$slots.default;

    return h(
      'button',
      {
        class: [
          'gs-button',
          `gs-button--${this.variant}`,
          `gs-button--${this.size}`,
          { 'is-loading': this.loading },
        ],
        attrs,
        on: this.$listeners,
      },
      content
    );
  },
};

const GsCard = {
  name: 'GsCard',
  inheritAttrs: false,
  render(h) {
    return h(
      'section',
      {
        class: 'gs-card',
        attrs: this.$attrs,
        on: this.$listeners,
      },
      this.$slots.default
    );
  },
};

const GsField = {
  name: 'GsField',
  inheritAttrs: false,
  props: {
    label: String,
    hint: String,
    error: String,
  },
  render(h) {
    return h(
      'div',
      {
        class: ['gs-field', { 'gs-field--error': Boolean(this.error) }],
        attrs: this.$attrs,
      },
      [
        this.label ? h('label', { class: 'gs-field__label' }, this.label) : null,
        h('div', { class: 'gs-field__control' }, this.$slots.default),
        this.error
          ? h('p', { class: 'gs-field__message gs-field__message--error' }, this.error)
          : this.hint
            ? h('p', { class: 'gs-field__message' }, this.hint)
            : null,
      ]
    );
  },
};

function createOverlayComponent(options) {
  return {
    name: options.name,
    inheritAttrs: false,
    props: {
      value: Boolean,
      title: String,
      subtitle: String,
      closeLabel: {
        type: String,
        default: 'Done',
      },
      closeVariant: {
        type: String,
        default: null,
      },
      size: {
        type: String,
        default: options.defaultSize,
      },
      hideHeader: Boolean,
      closeOnBackdrop: {
        type: Boolean,
        default: true,
      },
    },
    watch: {
      value(isOpen) {
        if (isOpen) {
          document.addEventListener('keydown', this.handleKeydown);
          this.$nextTick(() => {
            if (this.$refs.panel) this.$refs.panel.focus();
          });
        } else {
          document.removeEventListener('keydown', this.handleKeydown);
        }
      },
    },
    mounted() {
      if (this.value) document.addEventListener('keydown', this.handleKeydown);
    },
    beforeDestroy() {
      document.removeEventListener('keydown', this.handleKeydown);
    },
    methods: {
      close() {
        this.$emit('input', false);
        this.$emit('close');
      },
      closeFromBackdrop() {
        if (this.closeOnBackdrop) this.close();
      },
      handleKeydown(event) {
        if (event.key === 'Escape' && this.value) this.close();
      },
    },
    render(h) {
      if (!this.value) return h();

      const titleId = `${this._uid}-${options.rootClass}-title`;
      const panelChildren = [];
      if (!this.hideHeader) {
        const isDrawer = options.rootClass === 'gs-drawer';
        const heading = [h('h2', { attrs: { id: titleId } }, this.title || options.defaultTitle)];
        if (this.subtitle) {
          heading.push(h('p', { class: `${options.rootClass}__subtitle` }, this.subtitle));
        }
        panelChildren.push(
          h('header', { class: `${options.rootClass}__header` }, [
            h('div', { class: `${options.rootClass}__heading` }, heading),
            h(
              GsButton,
              {
                props: isDrawer ? { variant: this.closeVariant || 'primary', size: 'sm' } : { variant: 'ghost', size: 'icon' },
                attrs: { 'aria-label': isDrawer ? this.closeLabel : `Close ${options.defaultTitle.toLowerCase()}` },
                on: { click: this.close },
              },
              isDrawer ? [this.closeLabel] : [h(GsIcon, { props: { name: 'x', size: 18 } })]
            ),
          ])
        );
      }
      panelChildren.push(h('div', { class: `${options.rootClass}__body` }, this.$slots.default));

      return h(
        'div',
        {
          class: [options.rootClass, `${options.rootClass}--${this.size}`],
          attrs: this.$attrs,
        },
        [
          h('button', {
            class: `${options.rootClass}__backdrop`,
            attrs: { type: 'button', tabindex: '-1', 'aria-label': `Close ${options.defaultTitle.toLowerCase()}` },
            on: { click: this.closeFromBackdrop },
          }),
          h(
            options.panelTag,
            {
              ref: 'panel',
              class: [`${options.rootClass}__panel`, `${options.rootClass}__panel--${this.size}`],
              attrs: {
                role: 'dialog',
                'aria-modal': 'true',
                'aria-labelledby': !this.hideHeader ? titleId : null,
                'aria-label': this.hideHeader ? (this.title || options.defaultTitle) : null,
                tabindex: '-1',
              },
            },
            panelChildren
          ),
        ]
      );
    },
  };
}

const GsDrawer = createOverlayComponent({
  name: 'GsDrawer',
  rootClass: 'gs-drawer',
  panelTag: 'aside',
  defaultTitle: 'Drawer',
  defaultSize: 'lg',
});

const GsModal = createOverlayComponent({
  name: 'GsModal',
  rootClass: 'gs-modal',
  panelTag: 'section',
  defaultTitle: 'Dialog',
  defaultSize: 'lg',
});

const GsAlertDialog = {
  name: 'GsAlertDialog',
  components: { GsButton, GsModal },
  props: {
    value: Boolean,
    title: {
      type: String,
      default: 'Are you sure?',
    },
    copy: String,
    confirmLabel: {
      type: String,
      default: 'Confirm',
    },
    cancelLabel: {
      type: String,
      default: 'Cancel',
    },
    variant: {
      type: String,
      default: 'danger',
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
      this.$emit('cancel');
    },
    confirm() {
      this.$emit('confirm');
      this.$emit('input', false);
    },
  },
  render(h) {
    return h(
      GsModal,
      {
        class: 'gs-alert-dialog',
        props: {
          value: this.value,
          title: this.title,
          size: 'sm',
          closeOnBackdrop: false,
        },
        on: {
          input: value => this.$emit('input', value),
          close: this.close,
        },
      },
      [
        this.copy ? h('p', { class: 'gs-alert-dialog__copy' }, this.copy) : null,
        h('div', { class: 'gs-alert-dialog__actions' }, [
          h(
            GsButton,
            { props: { variant: 'secondary' }, on: { click: this.close } },
            this.cancelLabel
          ),
          h(
            GsButton,
            { props: { variant: this.variant }, on: { click: this.confirm } },
            this.confirmLabel
          ),
        ]),
      ]
    );
  },
};

const GsBadge = {
  name: 'GsBadge',
  inheritAttrs: false,
  props: {
    variant: {
      type: String,
      default: 'default',
    },
  },
  render(h) {
    return h(
      'span',
      {
        class: ['gs-badge', `gs-badge--${this.variant}`],
        attrs: this.$attrs,
      },
      this.$slots.default
    );
  },
};

let toastBus = null;

const GsToastProvider = {
  name: 'GsToastProvider',
  data() {
    return { toasts: [] };
  },
  mounted() {
    if (toastBus) toastBus.$on('show', this.showToast);
  },
  beforeDestroy() {
    if (toastBus) toastBus.$off('show', this.showToast);
  },
  methods: {
    showToast(payload) {
      const toast = typeof payload === 'string' ? { message: payload } : payload || {};
      const item = {
        id: `${Date.now()}-${Math.random()}`,
        message: toast.message || '',
        variant: toast.variant || 'default',
      };
      this.toasts.push(item);
      window.setTimeout(() => this.removeToast(item.id), toast.duration || 4000);
    },
    removeToast(id) {
      this.toasts = this.toasts.filter(toast => toast.id !== id);
    },
  },
  render(h) {
    return h(
      'div',
      {
        class: 'gs-toast-provider',
        attrs: { 'aria-live': 'polite', 'aria-atomic': 'false' },
      },
      this.toasts.map(toast =>
        h(
          'div',
          {
            key: toast.id,
            class: ['gs-toast', `gs-toast--${toast.variant}`],
            attrs: { role: toast.variant === 'danger' || toast.variant === 'error' ? 'alert' : 'status' },
          },
          [
            h('span', toast.message),
            h(
              'button',
              {
                attrs: { type: 'button', 'aria-label': 'Dismiss notification' },
                on: { click: () => this.removeToast(toast.id) },
              },
              '×'
            ),
          ]
        )
      )
    );
  },
};

const components = {
  GsAlertDialog,
  GsBadge,
  GsButton,
  GsCard,
  GsDrawer,
  GsField,
  GsIcon,
  GsModal,
  GsToastProvider,
};

const GrooveUIKitV2 = {
  components,
  install(Vue) {
    Object.keys(components).forEach(name => Vue.component(name, components[name]));

    if (!toastBus) toastBus = new Vue();
    const show = payload => toastBus.$emit('show', payload);
    Vue.prototype.$gsToast = {
      show,
      success: message => show({ message, variant: 'success' }),
      error: message => show({ message, variant: 'danger' }),
      info: message => show({ message, variant: 'default' }),
    };
  },
};

export { components };
export default GrooveUIKitV2;
